import {CommonMessages} from '../common.messages';

export const PanelSettingsGroupsMessages = {
    GetGroupsFailed: {
        key: 'GetGroupsFailed',
        message: 'Error while communication with the server. Enable to get available groups.'
    },
    ...CommonMessages
};
